import type { ILanguageResources, ITranslationModule } from '../../../interfaces';
import { interpolate } from '../../../global';

// eslint-disable-next-line @typescript-eslint/no-extraneous-class
class Id {
  private constructor() {}

  public static readonly prefix = 'UI.scripts.dealer-franchisee.conversation.WmBranchquoteSupport.';
  public static readonly supportSubject = `${Id.prefix}supportSubject`;
  public static readonly type = `${Id.prefix}type`;
  public static readonly status = `${Id.prefix}status`;
  public static readonly created = `${Id.prefix}created`;
  public static readonly modified = `${Id.prefix}modified`;
  public static readonly dateResolved = `${Id.prefix}dateResolved`;
  public static readonly resolution = `${Id.prefix}resolution`;
}

// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class LangDealerFranchiseeConversationWmBranchquoteSupport {
  private constructor() {}

  public static supportSubject(): string {
    return interpolate(Id.supportSubject);
  }

  public static type(): string {
    return interpolate(Id.type);
  }

  public static status(): string {
    return interpolate(Id.status);
  }

  public static created(): string {
    return interpolate(Id.created);
  }

  public static modified(): string {
    return interpolate(Id.modified);
  }

  public static dateResolved(): string {
    return interpolate(Id.dateResolved);
  }

  public static resolution(): string {
    return interpolate(Id.resolution);
  }
}

export class DealerFranchiseeConversationWmBranchquoteSupportModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(Id.supportSubject, "{{glossary 'support-subject'}}", 'Column title for support subject');
    register.add(Id.type, 'Type', 'Column title for support type');
    register.add(Id.status, 'Status', 'Column title for support status');
    register.add(Id.created, 'Created', 'Column title for created date');
    register.add(Id.modified, 'Modified', 'Column title for last modified');
    register.add(Id.dateResolved, 'Date Resolved', 'Column title for date resolved');
    register.add(Id.resolution, 'Resolution', 'Column title for resolution');
  }
}
